(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-complete-fit"]) return;
  try {
    
  (function () {
    /* Keep the bundle in sync with the size picked on the page for the current product. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-as-bundle-pdp]');
      if (!btn) return;
      var input = document.querySelector('[data-as-variant-input]');
      if (!input) return;
      var ids = btn.dataset.asBundle.split(',');
      ids[0] = input.value;
      btn.dataset.asBundle = ids.join(',');
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-full-fit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      (scope || document).querySelectorAll('[data-as-fit]').forEach(function (fit) {
        var chosen = {};
        var groups = fit.querySelectorAll('[data-as-pick]');
        var addBtn = fit.querySelector('[data-as-fit-add]');
        var ready = function () {
          var ok = Object.keys(chosen).length === groups.length;
          addBtn.disabled = !ok;
          addBtn.textContent = ok ? addBtn.dataset.readyLabel : addBtn.dataset.pickLabel;
        };
        addBtn.dataset.pickLabel = addBtn.textContent;
        addBtn.dataset.readyLabel = fit.dataset.addLabel || addBtn.textContent;
        groups.forEach(function (g) {
          g.addEventListener('click', function (e) {
            var b = e.target.closest('button[data-id]');
            if (!b) return;
            g.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
            chosen[g.dataset.asPick] = Number(b.dataset.id);
            ready();
          });
          var sel = g.querySelector('select');
          if (sel) sel.addEventListener('change', function () {
            if (sel.value) chosen[g.dataset.asPick] = Number(sel.value); else delete chosen[g.dataset.asPick];
            ready();
          });
        });
        addBtn.addEventListener('click', function (e) {
          var items = Object.keys(chosen).map(function (k) { return { id: chosen[k], quantity: 1 }; });
          if (window.asTheme) window.asTheme.addToBag(items, { x: e.clientX, y: e.clientY });
        });
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-main-cart"]) return;
  try {
    
  (function () {
    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var MAX_RECS = 3;

    /* Typing a quantity updates the bag right away. */
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-as-qty]')) return;
      var form = e.target.form;
      var input = document.createElement('input');
      input.type = 'hidden'; input.name = 'update'; input.value = '1';
      form.appendChild(input);
      form.submit();
    });
    document.addEventListener('as:cart-updated', function () {
      if (document.querySelector('[data-as-cart]')) window.location.reload();
    });

    /* One tap on a size adds that product to the bag. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-as-rec-add]');
      if (!btn) return;
      btn.classList.add('is-busy');
      btn.setAttribute('aria-busy', 'true');
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.asRecAdd), quantity: 1 }] })
      }).then(function (res) {
        if (!res.ok) throw new Error('cart/add ' + res.status);
        window.location.reload();
      }).catch(function (err) {
        console.error('[as-cart] could not add the recommended product', err);
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        var msg = document.querySelector('[data-as-recs-error]');
        if (msg) msg.hidden = false;
      });
    });

    /* Swap in products Shopify recommends for the first item in the bag; top up with the collection. */
    var recs = document.querySelector('[data-as-recs]');
    if (!recs || !recs.dataset.productId) return;
    var list = recs.querySelector('[data-as-recs-list]');
    var url = ROOT + 'recommendations/products?product_id=' + encodeURIComponent(recs.dataset.productId) + '&limit=10&section_id=as-cart-recs&intent=related';
    fetch(url).then(function (res) {
      if (!res.ok) throw new Error('recommendations ' + res.status);
      return res.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var picked = Array.prototype.slice.call(doc.querySelectorAll('[data-as-rec]'));
      var fallback = Array.prototype.slice.call(list.querySelectorAll('[data-as-rec]'));
      var seen = {};
      var cards = picked.concat(fallback).filter(function (card) {
        var id = card.dataset.asRec;
        if (seen[id]) return false;
        seen[id] = true;
        return true;
      }).slice(0, MAX_RECS);
      if (!cards.length) return;
      list.replaceChildren.apply(list, cards.map(function (card) { return document.importNode(card, true); }));
      recs.hidden = false;
    }).catch(function (err) {
      /* the collection cards already on the page stay as they are */
      console.warn('[as-cart] recommendations unavailable, keeping the collection', err);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-main-collection"]) return;
  try {
    
  (function () {
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-as-sort]')) return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
    /* Load more without leaving the page (the link still works without JavaScript). */
    document.addEventListener('click', function (e) {
      var more = e.target.closest('[data-as-more]');
      if (!more) return;
      e.preventDefault();
      more.setAttribute('aria-busy', 'true');
      fetch(more.href).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.querySelector('[data-as-col-grid]');
        doc.querySelectorAll('[data-as-col-grid] > .as-card').forEach(function (card) { grid.appendChild(card); });
        var next = doc.querySelector('[data-as-more]');
        if (next) { more.href = next.href; more.removeAttribute('aria-busy'); } else { more.parentElement.remove(); }
        if (window.asTheme) window.asTheme.watchImages(grid);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-related"]) return;
  try {
    
  (function () {
    function load(el) {
      if (!el || el.dataset.loaded) return;
      el.dataset.loaded = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-as-related]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          if (window.asTheme) window.asTheme.watchImages(el);
        }
      }).catch(function () {});
    }
    document.querySelectorAll('[data-as-related]').forEach(load);
    document.addEventListener('shopify:section:load', function (e) { load(e.target.querySelector('[data-as-related]')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-series"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.matchMedia('(hover: none)').matches) return;
    function light(row) {
      var cards = Array.prototype.slice.call(row.querySelectorAll('.as-char'));
      if (!cards.length) return;
      var mid = row.getBoundingClientRect().left + row.clientWidth / 2;
      var dist = function (c) { var b = c.getBoundingClientRect(); return Math.abs(b.left + b.width / 2 - mid); };
      var best = cards.reduce(function (a, c) { return dist(c) < dist(a) ? c : a; });
      cards.forEach(function (c) { c.classList.toggle('is-active', c === best); });
    }
    function init(scope) {
      (scope || document).querySelectorAll('[data-as-select]').forEach(function (row) {
        row.addEventListener('scroll', function () { light(row); }, { passive: true });
        light(row);
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
